export default __webpack_public_path__ + "static/media/Crypto-Defender-Logo.c3671633.svg";